<script>
  import { onMount } from "svelte";
  import { goto } from "$app/navigation";
  import { page } from "$app/state";
  import { SvgIcon } from "$lib/components";
  import { post } from "$lib/utils/api";
  import { menuConfig } from "$lib/utils/jump";
  import { browser } from "$app/environment";
  import { ripple } from "svelte-ripple-action";
  import Modal from "$lib/components/Modal/Modal.svelte";
  import { beforeNavigate, afterNavigate } from "$app/navigation";
  import { isTestAccount } from "../BBS/bbs.svelte";
  import { getIsTestAccount } from "$lib/utils/tools";
  let { moreButtonData, appMember, theme, custom } = $props();
  // 使用 Svelte 5 的 $state 声明
  let tabIndex = $state(2);
  /** 波浪元素 x轴距离 默认主页*/
  let waveX = $state("40vw");
  let status = $state(0);
  let footerElement = $state(null);
  let footerElementWidth = $state(430);
  let modalVsible = $state(false);
  let boxWidth = $state(0);
  let moreBtnEl = $state([]);
  let show = $state(false);
  const showModal = {
    title: "温馨提示",
    status: "warn",
    onCancel: () => (show = false),
    onConfirm: () => {},
    content: "",
  };
  const menuValidation = ["/my/wallet", "/my/recharge", "/my/withdraw", "/my/wallet/virtual"];
 
  // 使用 $state.raw 优化不变的数据，提高性能
  const tabList = $derived.by(() => {
    let d = { index: 0, name: "滚球", path: "/ball", icon: "nav-ball", preload: "off" };
    //滚球换心水配置
    if (custom?.ball2xs) {
      d.name = "心水";
      d.path = "/bbs/home?lotteryId=41";
      d.icon = "nav-bbs";
    }
    //滚球换优惠活动配置
    if (custom?.ball2yh) {
      d.name = "优惠";
      d.path = "/my/activities";
      d.icon = "nav-coupon";
    }
    return [d, { index: 1, name: "娱乐城", path: "/play", icon: "nav-play", preload: "off" }, { index: 2, name: "首页", path: "/", icon: "nav-home", preload: "off" }, { index: 3, name: "更多", path: "javascript:;", icon: "nav-more", preload: "off" }, { index: 4, name: "我的", path: "/my", icon: "nav-user", preload: "off" }];
  });

  // 优化菜单项和URL映射，合并为一个数据结构
  let menuItems = $state([]);

  const getMoreMenu = async () => {
    const res = await post("/LIVE-MEMBER/noauth/menuconfig/list", {
      homeType: "entertainment",
      position: 3,
    });
    if (res.code == 200) {
      formatMenuItems(res.items);
    }
  };

  let baseLocation = $state({ x: 0, y: 3 });
  const formatMenuItems = (items) => {
    if (!items || !items.length) return;
    const len = items.length;
    baseLocation.x = (footerElementWidth / 5 + 10) * 3 + 5;
    let rows = Math.ceil(len / 6);
    boxWidth = footerElement.offsetWidth;
    let w = 0;
    if (len < 6) {
      w = (boxWidth - 50 * len) / 2 - (2 * (boxWidth - 300)) / 7;
    }
    for (let i = 0; i < len; i++) {
      items[i].x = w + ((i + 1) * (boxWidth - 300)) / 7 + i * 50 - (Math.ceil((i + 1) / 6) - 1) * (boxWidth - (boxWidth - 300) / 7);
      items[i].y = (rows - Math.ceil((i + 1) / 6)) * ((boxWidth - 300) / 7 + 50) + 80;
    }
    // items.reverse()
    menuItems = items;
  };

  // 优化图片导入，使用 $state.raw 避免不必要的响应式
  const imgs = $state.raw(import.meta.glob("./assets/*.png", { eager: true, query: { enhanced: true } }));

  // 简化波浪动画配置
  const animConfig = $state.raw({
    duration: 150, // 减少动画时间，提高响应速度
    easing: "cubic-bezier(0.25, 0.1, 0.25, 1)", // 使用更平滑的缓动函数
  });

  // 波浪元素配置
  const waveConfig = $state.raw({
    width: 86, // 波浪SVG宽度
    offsetCenter: 41, // 波浪中心点偏移量
    footerItemWidth: 60, // 底部菜单项宽度
  });

  // 计算目标位置的函数，优先使用缓存
  function calculateTargetX(tabIndex) {
    if (browser) {
      return tabIndex * Math.floor(footerElementWidth / 5);
    } else {
      return `${tabIndex * 20}vw`;
    }
  }

  /**
   * 设置tabIndex 并设置wave x轴距离
   * @param index
   */
  function setTabIndex(index) {
    tabIndex = index;
    // 直接设置最终位置，使用CSS过渡
    waveX = String(calculateTargetX(tabIndex));
  }

  /**
   * 根据url设置tabIndex
   * @param url
   */
  function setTabIndxByUrl(url) {
    const currentPath = typeof url === "string" ? url : page.url.pathname || "/";
    const matchedTab = tabList.find(
      (item) =>
        item.index !== 3 && // 排除"更多"选项
        (currentPath === item.path || (item.path !== "/" && currentPath.startsWith(item.path.split("?")[0]))),
    );

    if (matchedTab !== undefined) {
      setTabIndex(matchedTab.index);
    }
  }

  // 更多按钮动画
  const animateCurve = (element, from, to, duration = 300) => {
    const startTime = performance.now();
    const deltaX = to.x - from.x;
    const deltaY = to.y - from.y;

    const curveHeight = 30; // 🎯 初始“弧度”，向上为负值

    // 缓动函数（ease-out cubic）
    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    // 二次贝塞尔轨迹
    function parabola(t) {
      const control = {
        x: from.x + deltaX / 2,
        y: (from.y + to.y) / 2 + curveHeight, // 控制点抬高 20 像素
      };

      const x = (1 - t) * (1 - t) * from.x + 2 * (1 - t) * t * control.x + t * t * to.x;
      const y = (1 - t) * (1 - t) * from.y + 2 * (1 - t) * t * control.y + t * t * to.y;

      return { x, y };
    }

    function step(currentTime) {
      const elapsed = currentTime - startTime;
      const rawProgress = Math.min(elapsed / duration, 1);

      const easedProgress = easeOutCubic(rawProgress); // 加缓冲
      const pos = parabola(easedProgress);

      element.style.transform = `translate(${pos.x}px, -${pos.y}px)`;

      if (rawProgress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  };

  const moreBtnMove = (visible) => {
    // type: true: 打开，false: 关闭
    modalVsible = visible;
    if (visible) {
      document.body.classList.add("overflow-hidden", "scrollbar-hide");
    } else {
      document.body.classList.remove("overflow-hidden", "scrollbar-hide");
      setTimeout(
        () => {
          if (tabIndex == 3) {
            tabIndex = lastTab;
          }
        },
        (moreBtnEl.length - 1) * 20,
      );
    }
    moreBtnEl.forEach((item, index) => {
      if (!item) return;

      setTimeout(() => {
        const d = menuItems[index];
        if (visible) {
          animateCurve(item, { x: baseLocation.x, y: baseLocation.y }, { x: d.x, y: d.y });
        } else {
          animateCurve(item, { x: d.x, y: d.y }, { x: baseLocation.x, y: baseLocation.y });
        }
      }, index * 20);
    });
  };

  // 点击事件 - 优化函数
  let lastTab = $state(-1);
  async function handleClick(item, e) {
    if (tabIndex === item.index) {
      if (item.index === 3) {
        moreBtnMove(false);
        setTabIndxByUrl();
      }
      e.stopPropagation();
      e.preventDefault();
      return;
    } // 避免重复点击
    lastTab = tabIndex;
    setTabIndex(item.index);
    if (item.index === 3) {
      moreBtnMove(true);
    } else {
      moreBtnMove(false);
      //await goto(item.path);
    }
  }
  /**
   * 更多遮罩层点击
   * @param e
   */
  function handleModalClick(e) {
    e.stopPropagation();
    moreBtnMove(false);
    setTabIndxByUrl();
  }

  // 更多点击处理 - 优化函数
  function toMenu(item) {
    if (["MORE.RECHARGE", "MORE.WITHDRAW", "MORE.WALLET", "MORE.PAY"].includes(item.code) && isTestAccount()) {
      return;
    }
    const code = item.code;
    const path = menuConfig(code);
    if (menuValidation.includes(path)) {
      if (!appMember?.realName) {
        showModal.title = "您需要完善账户信息";
        showModal.content = "为了您的账户和资金安全请完善账户数据";
        showModal.onConfirm = () => {
          show = false;
          goto("/my/profile/info");
        };
        show = true;
        return;
      }
    }
    if (path) {
      moreBtnMove(false);
      goto(path);
    }
  }
  /**
   * 布局发生改变，绑定事件
   */
  function bindResize() {
    setTimeout(() => {
      setTabIndxByUrl();
    });
  }
  afterNavigate(() => {
    setTabIndxByUrl();
    document.getElementById("app").scrollTop = 0;
  });
  onMount(() => {
    setTabIndxByUrl();
    if (moreButtonData?.length == 0) {
      getMoreMenu();
    } else {
      formatMenuItems(moreButtonData);
    }

    window.addEventListener("resize", bindResize);
    return () => {
      window.removeEventListener("resize", bindResize);
    };
  });
  setTabIndxByUrl();
</script>

<div bind:this={footerElement} bind:clientWidth={footerElementWidth} id="footer" class={`relative w-full ${page.data.isapp ? "h-[70px]  pb-[12px]" : "h-[56px]"} shrink-0 bg-white shadow-tab flex justify-evenly items-center z-[100] overscroll-none text-[#B4B4B4]`}>
  <div class="absolute h-[24px] left-0 -top-[23px] wave-element z-[1] flex justify-center items-center transform-gpu" style="width:20%; transform:translate3d({waveX.includes('vw') ? waveX : `${waveX}px`}, 0px, 0); will-change: transform; transition: transform {animConfig.duration}ms {animConfig.easing};">
    <svg class="absolute left-1/2 transform -translate-x-1/2" xmlns="http://www.w3.org/2000/svg" width={waveConfig.width} height="24" viewBox="0 0 86 24" fill="none">
      <g clip-path="url(#clip0_25081_290304)">
        <g filter="url(#filter0_d_25081_290304)">
          <path d="M17.9167 18.75C24.8701 13.0902 33.5619 10 42.5276 10H43.4724C52.4381 10 61.1299 13.0902 68.0833 18.75V18.75C72.2554 22.1459 77.4705 24 82.8499 24H86H0H3.15011C8.52954 24 13.7446 22.1459 17.9167 18.75V18.75Z" fill="white"></path>
        </g>
      </g>
      <defs>
        <filter id="filter0_d_25081_290304" x="-10" y="-1" width="106" height="34" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
          <feOffset dy="-1"></feOffset>
          <feGaussianBlur stdDeviation="5"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25081_290304"></feBlend>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_25081_290304" result="shape"></feBlend>
        </filter>
        <clipPath id="clip0_25081_290304">
          <rect width="86" height="24" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  </div>

  {#each tabList as item}
    <div class="flex flex-col items-center h-[56px] w-[20vw] relative z-10 {tabIndex === item.index ? 'text-[var(--primary)]' : 'text-[#B4B4B4]'}">
      <a use:ripple class="flex flex-col items-center justify-end h-full w-full relative" onclick={(e) => handleClick(item, e)} href={item.path}>
        <div class="flex items-end justify-center mb-[6px]">
          <SvgIcon name={item.icon} class="transition-all duration-150 transform-gpu" size={tabIndex === item.index ? 34 : 24} />
        </div>
        <div class="text-[12px] leading-none pb-[7px]">{item.name}</div>
      </a>
    </div>
  {/each}
</div>

<!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_static_element_interactions (because of reasons) -->
<div class="modal transition-all duration-300 z-[99] max-w-[430px] m-auto opacity-100 {modalVsible ? 'visible bg-[rgba(0,0,0,0.4)] pointer-events-auto' : 'bg-[rgba(0,0,0,0)] '}" onclick={handleModalClick}>
  {#if status === 0}
    <!-- <div class="w-full absolute bottom-[80px]"> -->
    {#each menuItems as item, index}
      <button
        use:ripple
        class="
            w-[54px] h-[54px] bg-[#FFFFFF] rounded-[6px] flex flex-col items-center justify-center absolute left-[0] bottom-0 transform
          "
        bind:this={moreBtnEl[index]}
        onclick={(e) => {
          e.stopPropagation();
          toMenu(item);
        }}
        aria-label={`菜单-${item.name}`}
      >
        <img src={item.icon} width="50" alt={item.name} class="w-[26px] h-[26px] rounded-[26px]" />
        <div class="text-[12px] text-[#333333]">{item.name}</div>
      </button>
    {/each}
    <!-- </div> -->
  {:else if status === 1}
    <enhanced:img src={imgs[`./assets/noData.png`].default} width="140" alt="noData" loading="lazy"></enhanced:img>
  {:else}
    <enhanced:img src={imgs[`./assets/noNet.png`].default} width="140" alt="noNet" loading="lazy"></enhanced:img>
  {/if}
</div>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:link="http://www.w3.org/1999/xlink" style="position: absolute; width: 0px; height: 0px;">
  <symbol fill="none" viewBox="0 0 21 20" id="icon-arrow-left"><path d="M11.86 4.167 13 5.369 8.612 10 13 14.63l-1.14 1.203L6.334 10l5.528-5.833Z" fill="currentColor"></path></symbol>
  <symbol fill="none" viewBox="0 0 24 24" id="icon-nav-coupon"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.0763 12.5643C21.0763 12.5643 20.238 13.769 19.9842 13.9973C19.7304 14.2256 19.6576 14.3119 19.248 14.3432C18.9273 14.3745 18.6278 14.6115 18.6501 15.035C18.6723 15.4585 18.4573 15.9739 18.4573 15.9739L13.9113 21.7059C13.2172 22.2202 12.3745 21.9036 12.3745 21.9036L9.71106 19.927L16.5302 13.1079C17.4143 12.3812 17.3702 11.4772 17.3702 11.4772C18.0646 11.4977 18.6501 10.988 18.6501 10.988L19.7421 9.89594L20.9725 10.8397C21.6134 11.7535 21.0763 12.5643 21.0763 12.5643ZM18.1065 10.3456C17.801 10.6661 17.3702 10.6421 17.3702 10.6421H16.5796V11.2351C16.6149 11.7242 16.3276 12.1245 16.3276 12.1245L9.11314 19.3834C8.11142 19.9077 7.33424 19.2846 7.33424 19.2846L0.959826 12.8163C0.374664 12.0515 1.01418 11.0374 1.01418 11.0374L7.93215 4.11943C8.48727 3.69339 9.01432 3.67471 9.01432 3.67471H9.60729V3.12621C9.59543 2.63845 10.0026 2.09346 10.0026 2.09346L11.8309 0.314552C12.9848 -0.47123 13.8124 0.462794 13.8124 0.462794L20.0337 6.68896C20.6255 7.61241 20.0337 8.46293 20.0337 8.46293L18.1065 10.3456ZM7.90542 15.112C8.34209 15.112 8.69604 14.7581 8.69604 14.3214C8.69604 13.8848 8.34209 13.5308 7.90542 13.5308C7.46879 13.5308 7.11479 13.8848 7.11479 14.3214C7.11479 14.7581 7.46879 15.112 7.90542 15.112ZM8.64663 9.03411C8.21 9.03411 7.856 9.38811 7.856 9.82473C7.856 10.2614 8.21 10.6154 8.64663 10.6154C9.0833 10.6154 9.43725 10.2614 9.43725 9.82473C9.43725 9.38811 9.0833 9.03411 8.64663 9.03411ZM5.55533 11.7786L5.55543 11.8256C5.27837 11.8505 5.01672 12.0831 5.01672 12.3666C5.01672 12.6668 5.30456 12.9102 5.56027 12.9102C5.64448 12.9102 5.68312 12.9056 5.72043 12.8976L11.0403 12.2728C11.3405 12.2728 11.5394 12.0739 11.5394 11.7292C11.5394 11.4735 11.3405 11.1856 11.0403 11.1856C11.0236 11.1856 11.0072 11.2312 10.991 11.2326L10.9909 11.1856L5.55533 11.7786ZM11.4356 4.95947C11.1354 4.95947 10.8921 5.24731 10.8921 5.50303C10.8921 5.84769 11.1354 6.04658 11.4356 6.04658C11.7358 6.04658 11.9347 5.84769 11.9347 5.50303C11.9347 5.24731 11.7358 4.95947 11.4356 4.95947ZM12.5277 6.14047C12.2719 6.14047 11.9841 6.38383 11.9841 6.63955C11.9841 6.98421 12.2719 7.22758 12.5277 7.22758C12.8723 7.22758 13.1157 6.98421 13.1157 6.63955C13.1157 6.38383 12.8723 6.14047 12.5277 6.14047ZM13.6592 7.22758C13.359 7.22758 13.1157 7.47094 13.1157 7.77113C13.1157 8.07132 13.359 8.31469 13.6592 8.31469C13.9594 8.31469 14.2028 8.07132 14.2028 7.77113C14.2028 7.47094 13.9594 7.22758 13.6592 7.22758ZM14.7513 8.31963C14.4956 8.31963 14.2522 8.60747 14.2522 8.86318C14.2522 9.20785 14.4956 9.40674 14.7513 9.40674C15.096 9.40674 15.2948 9.20785 15.2948 8.86318C15.2948 8.60747 15.096 8.31963 14.7513 8.31963Z" fill="currentColor"/></symbol>
  <symbol fill="none" viewBox="0 0 24 24" id="icon-nav-ball"
    ><path
      d="M15.073 2.485C9.826.79 4.179 3.68 2.485 8.928.79 14.174 3.68 19.822 8.927 21.517c5.247 1.693 10.894-1.197 12.588-6.444C23.21 9.826 20.32 4.179 15.073 2.485Zm-1.207 5.097 2.906-.95-.002-1.886a8.722 8.722 0 0 1 3.737 5.515l-1.72-.672-1.94 2.366-2.138-.126-1.536-2.106.693-2.141Zm-1.406-4.25-1.118 1.546 1.802 2.47-.674 2.09-2.512.822-1.783-1.146-.173-3.052-1.839-.486a8.712 8.712 0 0 1 6.297-2.244ZM5.02 13.769 3.967 15.29a8.635 8.635 0 0 1-.252-5.9l1.003 1.226a7.28 7.28 0 0 0-.054 2.334c.002.017.02.062.063.06.042-.004.059-.048.059-.063a7.196 7.196 0 0 1 .271-2.145L7.765 9.75l1.753 1.128.005 2.573-1.574 1.198-2.929-.88Zm4.31 6.502a8.628 8.628 0 0 1-2.58-1.357l1.506-.526a7.342 7.342 0 0 0 2.173.838c.017.004.066.002.078-.039.01-.041-.026-.07-.04-.077a7.194 7.194 0 0 1-1.997-1.038l-.063-2.82 1.552-1.18 2.522.814.571 1.874-1.842 2.442 1.033 1.476a8.624 8.624 0 0 1-2.913-.407Zm7.307-.928.03-1.662c.3-.248.586-.51.841-.801.114-.127.221-.261.325-.397.011-.013.03-.06-.001-.087-.033-.028-.076-.008-.085.003a7.247 7.247 0 0 1-1.294 1.062l-2.676-.923-.593-1.944 1.455-2.01 2.165.127 1.65 2.575 1.756-.46a8.645 8.645 0 0 1-3.573 4.517Z"
      fill="currentColor"
    ></path></symbol
  >
  <symbol fill="none" viewBox="0 0 24 24" id="icon-nav-home"><g clip-path="url(#icon-nav-home_a)"><path d="m12.88 3.342 8.878 8.139a.745.745 0 0 1-.502 1.294l-.88-.001v6.516a1.86 1.86 0 0 1-1.86 1.862H5.482a1.861 1.861 0 0 1-1.862-1.862v-6.516h-.878a.744.744 0 0 1-.502-1.293l8.877-8.139a1.303 1.303 0 0 1 1.762 0ZM7.589 14.035a.931.931 0 0 0 0 1.317 6.108 6.108 0 0 0 8.638 0 .93.93 0 0 0-1.316-1.317 4.247 4.247 0 0 1-6.005 0 .93.93 0 0 0-1.317 0Z" fill="currentColor"></path></g><defs><clipPath id="icon-nav-home_a"><path fill="#fff" d="M0 0h24v24H0z"></path></clipPath></defs></symbol>
  <symbol fill="none" viewBox="0 0 24 24" id="icon-nav-more"><path d="M16.298 11.582h1.822A3.885 3.885 0 0 0 22 7.702V5.88A3.884 3.884 0 0 0 18.12 2h-1.822a3.884 3.884 0 0 0-3.88 3.88v1.822a3.885 3.885 0 0 0 3.88 3.88ZM5.88 11.67h1.822a3.885 3.885 0 0 0 3.88-3.88V5.967a3.885 3.885 0 0 0-3.88-3.88H5.88A3.884 3.884 0 0 0 2 5.968v1.821a3.884 3.884 0 0 0 3.88 3.88ZM5.88 21.903h1.822a3.885 3.885 0 0 0 3.88-3.88V16.2a3.885 3.885 0 0 0-3.88-3.88H5.88A3.884 3.884 0 0 0 2 16.2v1.822a3.885 3.885 0 0 0 3.88 3.88ZM16.298 21.815h1.822A3.885 3.885 0 0 0 22 17.934v-1.822a3.885 3.885 0 0 0-3.88-3.88h-1.822a3.884 3.884 0 0 0-3.88 3.881v1.822a3.885 3.885 0 0 0 3.88 3.88Z" fill="currentColor"></path></symbol>
  <symbol fill="none" viewBox="0 0 24 24" id="icon-nav-play"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.59 17.43 11.96 3.435a.648.648 0 0 0-.823-.4L2.454 5.905a.648.648 0 0 0-.422.814L6.66 20.714c.11.336.48.515.823.402l8.684-2.873a.648.648 0 0 0 .422-.813Zm-6.207-2.632-.005-.006.004.01c-2.232-.185-5.441-1.673-4.465-3.58.977-1.907 2.837-.465 2.837-.465l.002.003.001-.01s.345-2.327 2.37-1.627c2.025.7.738 3.996-.744 5.675ZM21.32 5.774a.67.67 0 0 0-.706-.631l-2.11.096 2.283 14.069a.655.655 0 0 1-.523.747l-8.108 1.505a.679.679 0 0 0 .605.312l8.592-.388A.67.67 0 0 0 22 20.79l-.68-15.017ZM17.008 4.48l2.36 14.55a.655.655 0 0 1-.522.747l-8.722 1.619a.619.619 0 0 1-.359-.04l7.627-2.523a.648.648 0 0 0 .422-.813l-.233-.707-.013.002L13.346 4.51l2.934-.545a.62.62 0 0 1 .728.515Z" fill="currentColor"></path></symbol>

  <symbol fill="none" viewBox="0 0 24 24" id="icon-nav-user"><path d="M12.169 15.333c9.247 0 9.156 5.725 9.156 5.725.07.52-.305.942-.839.942H3.851c-.533 0-.929-.427-.838-.942 0 0-.093-5.725 9.156-5.725ZM12.166 2H18v5.833A5.833 5.833 0 1 1 12.166 2Z" fill="currentColor"></path></symbol>
  <symbol viewBox="0 0 20 20" fill="none" id="icon-nav-bbs">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7957 6.30072H17.7071C18.3899 6.30072 19.0372 6.60502 19.4728 7.1308C19.9084 7.65658 20.087 8.34914 19.96 9.02L18.3143 17.7021C18.109 18.7845 17.1631 19.5679 16.0614 19.5679H1.50357C0.672856 19.5679 0 18.895 0 18.0643V9.38215C0 8.55175 0.673171 7.87858 1.50357 7.87858L4.13142 7.88286C5.78357 7.72358 7.08285 6.27572 7.08285 4.57787V3.2543C7.08285 1.7893 7.72856 0.648585 9.08142 0.452157C10.6157 0.2293 12.2186 1.90858 12.2186 3.66215C12.2186 4.43501 12.0764 5.31287 11.7957 6.30072ZM1.42392 9.38556V18.0677C1.42392 18.1091 1.4575 18.1427 1.49892 18.1427H3.20963V9.31056H1.49892C1.45749 9.31056 1.42392 9.34413 1.42392 9.38556Z" fill="currentColor"></path>
  </symbol>
</svg>

<Modal {show} title={showModal.title} status={showModal.status} onCancel={showModal.onCancel} onConfirm={showModal.onConfirm}>
  <div class="text-[14px] font-[400] flex flex-col items-center justify-center">
    <div class="text-[var(--primary-500)] text-[14px]">{showModal.content}</div>
  </div>
</Modal>

<style>
  [data-theme="orange"] {
    --primary: #ff7e07;
    --primary-500: #ffa82e;
  }
  [data-theme="blue"] {
    --primary: #4c9eea;
    --primary-500: #5faffb;
  }
  [data-theme="purple"] {
    --primary: #716ac7;
    --primary-500: #6561ae;
  }

  [data-theme="gold"] {
    --primary: #dca340;
    --primary-500: #f3c780;
  }
</style>
